import { useState, type FormEvent } from "react";
import { Button, FormRow, Modal, ModalFooter, TextField, useToast } from "@plataforma/design-system";
import { formatCpf, type Client } from "@plataforma/shared";
import { errorMessage } from "../../lib/api";
import { useSaveClient } from "./api";

export function ClientForm({ client, onClose, onSaved }: { client?: Client; onClose: () => void; onSaved?: (client: Client) => void }) {
  const [values, setValues] = useState({ name: client?.name ?? "", phone: client?.phone ?? "", email: client?.email ?? "", cpf: formatCpf(client?.cpf) });
  const [dirty, setDirty] = useState(false);
  const [error, setError] = useState<string | null>(null);
  const save = useSaveClient(client?.id);
  const toast = useToast();
  const set = (field: keyof typeof values) => (event: { target: { value: string } }) => {
    setValues((current) => ({ ...current, [field]: event.target.value }));
    setDirty(true);
  };

  async function submit(event: FormEvent) {
    event.preventDefault();
    setError(null);
    try {
      const saved = await save.mutateAsync(values);
      toast(client ? "Cadastro atualizado." : "Cadastro salvo.");
      onSaved?.(saved);
      onClose();
    } catch (failure) {
      setError(errorMessage(failure));
    }
  }

  return (
    <Modal title={client ? "Editar cadastro" : "Novo cadastro"} onClose={onClose} dirty={dirty}>
      <form onSubmit={submit}>
        <TextField label="Nome completo" required autoComplete="off" value={values.name} onChange={set("name")} />
        <FormRow>
          <TextField label="Telefone / WhatsApp" type="tel" required autoComplete="off" value={values.phone} onChange={set("phone")} />
          <TextField label="E-mail (opcional)" type="email" autoComplete="off" value={values.email} onChange={set("email")} />
        </FormRow>
        <TextField label="CPF (opcional)" inputMode="numeric" autoComplete="off" value={values.cpf} onChange={set("cpf")} hint="Peça apenas quando for necessário para a nota fiscal." />
        {error ? <p className="ds-field__error" role="alert">{error}</p> : null}
        <ModalFooter>
          <Button onClick={onClose}>Cancelar</Button>
          <Button type="submit" variant="primary" disabled={save.isPending}>Salvar cadastro</Button>
        </ModalFooter>
      </form>
    </Modal>
  );
}
